'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var List_module = require('../styles/List.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description List item element.
 *
 * @component
 * @example
 * ```jsx
 * <ListItem>...</ListItem>
 * ```
 */
const ListItem = React__namespace.forwardRef((props, ref) => {
    const { icon, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(List_module.default);
    const classNames = cx(className, 'item', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'with-icon': icon,
    });
    return (React__namespace.createElement("li", { ref: ref, className: classNames, ...restProps },
        icon ? React__namespace.createElement("span", { className: cx('icon') }, icon) : null,
        children));
});
ListItem.displayName = 'ListItem';

exports.ListItem = ListItem;
//# sourceMappingURL=ListItem.js.map
